import { Checkbox, Grid } from '@mui/material';
import { useProvideSnackBar } from '../../hooks';
import { useRequirementStopPassengerDataContext } from '../../hooks/useRequirementStopPassengerCount';
import { useState } from 'react';
import { usePreconfiguredFetch } from '../../hooks/useProvidePreconfiguredFetch';

interface PassengerCheckboxesCellProps {
    rowId: number;
    dueAt: string;
    stopId: number;
    requirementId: number;
    stopCrmId: number;
    passengerId: number;
    passengerTravel: boolean;
    updateDataGridRows: (rowId: number, dueAt: string, stopId: number, passengerTravel: boolean) => void;
}

const PassengerCheckboxesCell: React.FC<PassengerCheckboxesCellProps> = ({
    rowId,
    dueAt,
    stopId,
    requirementId,
    stopCrmId,
    passengerId,
    passengerTravel,
    updateDataGridRows,
}) => {
    const { showError, showResponseError } = useProvideSnackBar();
    const { fetchResource } = usePreconfiguredFetch();
    const { changeNPassengers } = useRequirementStopPassengerDataContext();
    const [travel, setTravel] = useState<boolean>(passengerTravel);

    const fetchPassengerTravel = async (isTravel: boolean) => {
        try {
            const response = await fetchResource('/api/travels', {
                method: 'POST',
                body: JSON.stringify({
                    RequirementStopPassengerID: passengerId,
                    Travel: isTravel,
                }),
            });

            if (response.ok) {
                updateDataGridRows(rowId, dueAt, stopId, isTravel);
                changeNPassengers(requirementId, stopCrmId, passengerId, isTravel);
                setTravel(isTravel);
            } else {
                showResponseError(response);
            }
        } catch (error: any) {
            showError('Hiba történt: ' + error.message);
        }
    };

    return (
        <Grid style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Checkbox
                size='small'
                key={passengerId}
                checked={travel}
                onChange={event => {
                    fetchPassengerTravel(event.target.checked);
                }}
                sx={{ padding: 0, paddingTop: 0 }}
            />
        </Grid>
    );
};

export default PassengerCheckboxesCell;
